function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M13 3.513L9.867.38.308 9.939l3.133 3.133z"
}), React.createElement("path", {
  d: "M9.866 19.5l3.133-3.133-9.56-9.56L.306 9.94z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 20
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow-left.svg";
export { SvgComponent as ReactComponent };